<template>
  <ListingBlockLayout title="Books" class="books-block-skeleton">
    <BookCardSkeleton v-for="i in numberOfCardsToRender" :key="i" />
  </ListingBlockLayout>
</template>

<script setup lang="ts">
import ListingBlockLayout from '@/app/components/listing/ListingBlockLayout.vue'
import BookCardSkeleton from '@/app/components/listing/skeleton-loaders/BookCardSkeleton.vue'

const numberOfCardsToRender = 4
</script>

<style lang="scss" scoped>
.books-block-skeleton {
  --listing-block-number-of-columns: 4;
  --listing-block-items-width-mobile: 220px;
}
</style>
